// non-template file
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { Roles } from "@/helpers/enums/Roles";
import $ from "jquery";

import { useStore } from "@/store";
const store = useStore();

const data: any = {
  filter: {
    title: "userfilter",
    pageName: "userfilter",
    genre: "filter",
    ignoreSaveFilter: true,
    noDateSelect: true,
    hideFilter: false,
    quickSearch: "fullTextSearch",
    filters: [
      {
        title: "firstname",
        type: "wordstyped",
        apiEquivalent: "firstName",
        param: "firstName",
        vmodel: ''
      },
      {
        title: "lastname",
        type: "wordstyped",
        apiEquivalent: "lastName",
        param: "lastName",
        vmodel: ''
      },
      {
        title: "loginidemail",
        type: "wordstyped",
        apiEquivalent: "loginId",
        param: "loginId",
        vmodel: ''
      },
    ],
  },
  header: {
    title: "userlist",
    buttonPosition: "justify-content-between",
    buttons: [
      {
        title: "newuser",
        icon: "add",
        class: "primary mr-3",
        link: "",
        target: "#agUserModal",
        toggle: "modal",
        function: (module: any) => {
          store.dispatch(
            GeneralActionTypes.SET_COMPKEY,
            store.getters.compKey + 1
          );
        },
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "firstname",
          field: "firstName",
          sortable: true,
        },
        {
          label: "lastname",
          field: "lastName",
          sortable: true,
        },
        {
          label: "loginidemail",
          field: "email",
          sortable: true,
        },
        {
          label: "role",
          field: "role",
          sortable: true,
        },
        {
          label: "createdon",
          field: "createdAt",
          sortable: true,
          components: [
            {
              component: "tableDateFormatter",
              field: "createdAt",
            },
          ],
        },
        {
          label: "lastlogin",
          sortable: true,
          field: "lastLogin",
          components: [
            {
              component: "tableDateFormatter",
              field: "lastLogin",
            },
          ],
        },
        {
          label: "assignedAssets",
          field: "assignedAssets",
          components: [
            {
              component: "userAsset",
            },
          ],
          sortable: false,
        },
        {
          label: "commands",
          field: "commands",
          components: [
            {
              component: "tableEditComponent",
              target: "#agUserModal",
            },
            {
              component: "tableResetPassComponent",
              target: "#userResetPassModal",
            },
            {
              component: "tableDeleteComponent",
              class: "mr-2 ml-2",
            },
            // {
            //   component: "tableReloadComponent",
            // },
          ],
        },
      ],
      rows: [],
      sortable: {
        order: "createdAt",
        sort: "desc",
      },
      total: 0,
      page: 1,
      pageSize: 5,
      isLoading: false,
      fetchTable: (options: any) => {
        store.dispatch(GeneralActionTypes.GET_USERS, {
          options: options,
          filters: {}
        });
      },
    },
  },
};

export default data;
